export default function Label() {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          lineHeight: '1.7em',
        },
      },
    },
  };
}
